const X_PROFILE_URL = 'https://x.com/toolnovaHQ';
const X_HANDLE = '@toolnovaHQ';

interface XFollowWidgetProps {
  variant?: 'banner' | 'card';
}

export default function XFollowWidget({ variant = 'banner' }: XFollowWidgetProps) {
  if (variant === 'card') {
    return (
      <div className="rounded-xl border border-gray-800 bg-gray-900/60 p-5 flex flex-col items-start gap-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-black border border-gray-700">
            <i className="ri-twitter-x-line text-white text-sm"></i>
          </div>
          <span className="text-sm font-semibold text-white">Follow on X</span>
        </div>
        <p className="text-sm text-gray-400 leading-relaxed">
          Follow <span className="text-white font-medium">{X_HANDLE}</span> on X for daily AI tool picks
        </p>
        <a
          href={X_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 bg-black hover:bg-gray-900 border border-gray-700 hover:border-gray-500 text-white text-sm font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-twitter-x-line text-sm"></i>
          </div>
          Follow {X_HANDLE}
        </a>
      </div>
    );
  }

  // Banner variant
  return (
    <div className="w-full flex items-center justify-between gap-4 px-6 py-4 bg-gray-900 border border-gray-800 rounded-xl">
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-black border border-gray-700 flex-shrink-0">
          <i className="ri-twitter-x-line text-white text-lg"></i>
        </div>
        <p className="text-sm md:text-base text-gray-300">
          Follow{' '}
          <a
            href={X_PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white font-semibold hover:text-teal-400 transition-colors cursor-pointer"
          >
            {X_HANDLE}
          </a>{' '}
          on X for daily AI tool picks
        </p>
      </div>
      <a
        href={X_PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2 bg-black hover:bg-gray-800 border border-gray-700 hover:border-gray-500 text-white text-sm font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-twitter-x-line text-sm"></i>
        </div>
        Follow
      </a>
    </div>
  );
}
